

























































































































































import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { State,Getter } from 'vuex-class';
import { BbvaDocument } from '../store/bbva-document/types';
import { ConsumerApplicationState, ConsumerApplicationStatus } from '../store/consumer-application/types'
import IdentityFields from '@/components/IdentityFields.vue';
import AddressFields from '@/components/AddressFields.vue';
import ContactInformationFields from '../components/ContactInformationFields.vue';
import IdentityVerificationFields from '../components/IdentityVerificationFields.vue';
import EmploymentAndIncomeFields from '../components/EmploymentAndIncomeFields.vue';
// TODO: CARD-285 Disabled mailing address.
// import AdditionalCardholderFields from '../components/AdditionalCardholderFields.vue';

const namespace = 'bbvaDocument';

@Component({
	name: 'apply-now-section',
	components: {
		'identity-fields': IdentityFields,
		'address-fields': AddressFields,
		'contact-information-fields': ContactInformationFields,
		'identity-verification-fields': IdentityVerificationFields,
		'employment-and-income-fields': EmploymentAndIncomeFields,
		// TODO: CARD-285 Disabled mailing address.
		/*'additional-cardholder-fields': AdditionalCardholderFields,*/
	},
})

export default class ApplyNowSection extends Vue {

	haveReadCheckBox = false;
	electronicCommunicationsAgreementCheckbox = false;
	bbvaTermsOfUseCheckBox = false;
	bbvaPrefs = '';

	@Getter('document', { namespace }) bbvaDocument?: BbvaDocument;
	@State('consumerApplication') consumerApplication?: ConsumerApplicationState;


	data() {
		return {
			valid: false,
		};
	}

	submitApplication() {
		if(this.$data.valid){
			const button = document.getElementById('apply-now');
			if (button != null) {
				button.classList.remove('apply-now-button');
				button.classList.add('apply-now-button-disabled-button-after-click');
			}
			document.getElementById('deviceId')!.click();
			this.bbvaPrefs = (document.getElementById('bbva_prefs') as HTMLInputElement).value;
			this.$store.commit('consumerApplication/SET_CONSUMER_APPLICATION_DEVICE_ID', this.bbvaPrefs, { root: true });	
			this.$store.commit('consumerApplication/SET_CONSUMER_APPLICATION_VALID', true );
			this.$store.commit('consumerApplication/SET_CONSUMER_APPLICATION_STATUS', ConsumerApplicationStatus.STARTED );
			this.$store.dispatch('consumerApplication/postConsumerApplication', { root: true });
		}
	}
}
